export class EODocument {
  eoNumber: string;
  revisionDate: Date;
  revisionCode: string;
  eaTitle: string;
  enteredBy: string;
  optixHostID: number;
  optixID: number;
  optixTypeID: string;
}
